import { DefaultPortModel, PathFindingLinkModel, PortModelAlignment } from '@projectstorm/react-diagrams';

export default class PortModel extends DefaultPortModel {
  constructor({ name, input }) {
    super({
      name,
      in: input,
      alignment: PortModelAlignment.BOTTOM,
      type: "NG_INSIGHT_DIAGRAM_NODE"
    });
  }

  // TODO do not create a link on output
  createLinkModel = () => 
    new PathFindingLinkModel({
      width: "1px",
      color: "black",
      selectedColor: "#2387da"
    });

  canLinkToPort = port => {
    if(port.parent.getId() === this.parent.getId() && this.parent.getId() !== undefined) {
      return false;
    }
    if (port.getOptions().in === true && this.getOptions().in === true) {
      return false;
    }
    if (port.getOptions().in === false && this.getOptions().in === false) {
      return false;
    }
    if(this.getOptions().in === true) {
      return false;
    }
    return true;
  };

  getName = () => this.getOptions().name;

  getType = () => this.getOptions().type;

  isInput = () => this.getOptions().in

  getParentId = () => this.parent?.getId()
}